import { z } from 'zod'
import { FIELD_CANNOT_BE_EMPTY } from '../../../../consts/validationErrors'
import type { GrowthToolContentType, GrowthToolSourceType } from '../../../../api/types/growthTools'

export const growthToolSourceTypes = ['user', 'classic', 'science', 'editorial', 'ai'] as const
export const growthToolContentTypes = ['text', 'audio', 'video'] as const

const sourceTypeSet = new Set<string>(growthToolSourceTypes)
const contentTypeSet = new Set<string>(growthToolContentTypes)

export const resolveGrowthToolSourceTypes = (value: unknown): GrowthToolSourceType[] => {
    const items = Array.isArray(value) ? value : value == null || value === '' ? [] : [value]
    const result: GrowthToolSourceType[] = []
    for (const item of items) {
        const candidate = String(item)
        if (sourceTypeSet.has(candidate) && !result.includes(candidate as GrowthToolSourceType)) {
            result.push(candidate as GrowthToolSourceType)
        }
    }
    return result
}

export const resolveGrowthToolContentTypes = (value: unknown): GrowthToolContentType[] => {
    const items = Array.isArray(value) ? value : value == null || value === '' ? [] : [value]
    const result: GrowthToolContentType[] = []
    for (const item of items) {
        const candidate = String(item)
        if (contentTypeSet.has(candidate) && !result.includes(candidate as GrowthToolContentType)) {
            result.push(candidate as GrowthToolContentType)
        }
    }
    return result
}

/** @deprecated use resolveGrowthToolSourceTypes */
export const resolveGrowthToolSourceType = (value: unknown): GrowthToolSourceType =>
    resolveGrowthToolSourceTypes(value)[0] ?? 'user'

/** @deprecated use resolveGrowthToolContentTypes */
export const resolveGrowthToolContentType = (value: unknown): GrowthToolContentType =>
    resolveGrowthToolContentTypes(value)[0] ?? 'text'

export const DEFAULT_GROWTH_TOOL_SOURCE_TYPE: GrowthToolSourceType = 'user'
export const DEFAULT_GROWTH_TOOL_CONTENT_TYPE: GrowthToolContentType = 'text'

export const growthToolFormSchema = z.object({
    title: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .min(2, { message: 'Минимально 2 символа' })
        .max(240, { message: 'Максимально 240 символов' }),
    description: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .min(2, { message: 'Минимально 2 символа' })
        .max(2000, { message: 'Максимально 2000 символов' }),
    image: z
        .union([z.string(), z.instanceof(File), z.null()]),
    source_type: z.array(z.enum(growthToolSourceTypes)),
    content_type: z.array(z.enum(growthToolContentTypes)),
})

export type growthToolFormValues = z.infer<typeof growthToolFormSchema>
export type GrowthToolFormValues = growthToolFormValues
